<template>
  <div class="space-y-32">
    <Info @create="handleCreate" />

    <RevCard class="p-32">
      <h3 class="heading-3 mb-16">
        {{ i18n(translations.title) }}
      </h3>

      <div v-if="hasIntegrations">
        <p class="body-1 mb-16">
          {{ i18n(translations.withIntegrationsSubtitle) }}
        </p>

        <IntegrationsList
          :integrations="integrations.results"
          @deleted="handleDeleted"
        />
      </div>

      <EmptyState v-if="!hasIntegrations" />
    </RevCard>

    <CreateIntegrationForm @created="handleCreated" />

    <ModalOnboarding
      :button-label="i18n(translations.onboardingModalButtonLabel)"
      :title="i18n(translations.onboardingModalTitle)"
    >
      <template #description>
        {{ i18n(translations.onboardingModalDescription) }}
      </template>
      <template #to-do>
        {{ i18n(translations.onboardingModalToDoSection) }}
      </template>
      <template #done>
        {{ i18n(translations.onboardingModalDoneSection) }}
      </template>
    </ModalOnboarding>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { merchantsAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { openModal } from '@ds/components/ModalBase'

import { MODAL_NAMES } from './Integration.constants'
import translations from './Integrations.translations'
import CreateIntegrationForm from './components/CreateIntegrationForm/CreateIntegrationForm.vue'
import EmptyState from './components/EmptyState/EmptyState.vue'
import Info from './components/Info/Info.vue'
import IntegrationsList from './components/IntegrationsList/IntegrationsList.vue'

const i18n = useI18n()

const { data: integrations, refresh } = await useHttpFetch(
  merchantsAPI.getIntegrations,
  {
    default: () => ({ results: [], count: 0 }),
  },
)

const hasIntegrations = computed(() => integrations.value.count > 0)

function handleCreate() {
  openModal(MODAL_NAMES.CREATE)
}
function handleDeleted() {
  refresh()
}
function handleCreated() {
  refresh()
}
</script>
